/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-11-14 09:43:51
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-11-30 11:41:28
 * @FilePath: \H5\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import VueRouter from "vue-router";
const Index = () =>
  import(/* webpackChunkName: "index" */ "../views/Index.vue");
const Home = () => import(/* webpackChunkName: "home" */ "../views/Home.vue");
const GoodsInfo = () =>
  import(/* webpackChunkName: "goodsInfo" */ "../views/GoodsInfo.vue");

const SecurityInfo = () =>
  import(/* webpackChunkName: "securityInfo" */ "../views/SecurityInfo.vue");

const EnterpriseInfo = () =>
  import(
    /* webpackChunkName: "enterpriseInfo" */ "../views/EnterpriseInfo.vue"
  );
const QsInfo = () =>
  import(/* webpackChunkName: "qsInfo" */ "../views/QsInfo.vue");

const Look = () => import(/* webpackChunkName: "view" */ "../views/Look.vue");
const Anti = () => import('../views/anti-fake.vue')
const Advertising = () => import('../views/advertising.vue')
const Tem = () => import('../views/tem.vue')
const Enterprise = () => import('../views/enterprise.vue')
const Tradeinfo = () => import('../views/Tradeinfo.vue')
const antiInfo = () => import('../views/antiInfo.vue')
const qDetails = () => import('../views/qDetails.vue')
const QualityTesting = () => import('../views/qualityTesting.vue')
const CirculationInfo = () =>
  import(
    /* webpackChunkName: "circulationInfo" */ "../views/CirculationInfo.vue"
  );
const PlantInfo = () =>
  import(/* webpackChunkName: "plantInfo" */ "../views/PlantInfo.vue");
const ProcessInfo = () =>
  import(/* webpackChunkName: "crocessInfo" */ "../views/ProcessInfo.vue");
const Result = () =>
  import(/* webpackChunkName: "result" */ "../views/Result.vue");
const Demo = () =>
  import(/* webpackChunkName: "result" */ "../views/demo.vue");
const TraceCenterPage = () =>
  import(/* webpackChunkName: "TraceCenterPage" */ "../views/TraceCenterPage.vue");
const Intelligent = () =>
  import(/* webpackChunkName: "TraceCenterPage" */ "../views/Intelligent.vue");
/**
 * 重写路由的push方法--->这个是vue-cli4.x以上的坑，不然的话，你是跳转不了的
 */
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "Index",
    component: Index,
  },
  {
    path:"/TraceCenterPage",
    name:"TraceCenterPage",
    component:TraceCenterPage,
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    children: [
      { path: "/goodsInfo", component: GoodsInfo },
      { path: "/securityInfo", component: SecurityInfo },
      { path: "/enterpriseInfo", component: EnterpriseInfo },
      { path: "/qsInfo", component: QsInfo },
      { path: "/circulationInfo", component: CirculationInfo },
      { path: "/plantInfo", component: PlantInfo, props: true },
      { path: "/processInfo", component: ProcessInfo },
      { path: "/intelligent", component: Intelligent },
      { path: "/demo", component:  Demo},
      { path: "/anti-fake", component:  Anti},
      { path: "/advertising", component:  Advertising},
      { path: "/tem", component:  Tem},
      { path: "/enterprise", component:  Enterprise},
      { path: "/Tradeinfo", component:  Tradeinfo},
      { path: "/qualityTesting", component:  QualityTesting},
    ],
  },
  { path: "/antiInfo", component: antiInfo },
  { path: "/look", component: Look },
  { path: "/result", component: Result },
  { path: "/qDetails", component: qDetails },
];

const router = new VueRouter({
  routes,
});

export default router;
